<div class="schedule-form-item clearfix">
  <ng-content></ng-content>
  <mode-email-embeds
    [selections]="selections"
    [disableAttachments]="disableEmailAttachments"
    (embedsSelected)="updateEmailSettings($event)"
    data-test="embeds"
  ></mode-email-embeds>
  <mode-email-attachments
    [selections]="selections"
    [disableAttachments]="disableEmailAttachments"
    (attachmentsSelected)="updateEmailSettings($event)"
    data-test="attachments"
  ></mode-email-attachments>

  <p *ngIf="testEmail" class="send-a-test-email">
    <button (click)="sendTestEmail.emit()" class="info-link info-button" data-test="send-test-email">
      Send a test email
    </button>
    to {{ testEmail }}
  </p>
</div>
